// @ts-nocheck
import { useEffect, useState, useRef } from "react";

const PHRASES = ["is thinking", "is analyzing", "is composing"];

interface TypingIndicatorProps {
  agentNames: string[];
}

export function TypingIndicator({ agentNames }: TypingIndicatorProps) {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (agentNames.length === 0) return;

    const cycle = () => {
      const delay = 2000 + Math.random() * 2000;
      timeoutRef.current = setTimeout(() => {
        setPhraseIndex((i) => (i + 1) % PHRASES.length);
        cycle();
      }, delay);
    };
    cycle();

    return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); };
  }, [agentNames.length]);

  if (agentNames.length === 0) return null;

  const label = agentNames.length === 1
    ? agentNames[0]
    : `${agentNames.slice(0, -1).join(", ")} and ${agentNames[agentNames.length - 1]}`;

  return (
    <div className="flex justify-start" data-testid="typing-indicator">
      <div className="bg-muted rounded-lg p-3 max-w-[70%]">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span className="inline-flex gap-0.5">
            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:0ms]" />
            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:150ms]" />
            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:300ms]" />
          </span>
          <span className="italic">{label} {PHRASES[phraseIndex]}...</span>
        </div>
      </div>
    </div>
  );
}
